import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { LiSnState } from "@/types/liSn";

import { liSnApi } from "./liSn.api";

const initialState: LiSnState = {
	liSns: [],
	preview: null,
};

export const liSnSlice = createSlice({
	name: "liSn",
	initialState,
	reducers: {
		clearLiSnPreview: (state) => {
			state.preview = null;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(liSnApi.endpoints.getLiSns.matchFulfilled, (state, { payload }) => {
			if (payload?.data) {
				state.liSns = payload.data;
			}
		});
		builder.addMatcher(liSnApi.endpoints.previewLiSn.matchFulfilled, (state, { payload }) => {
			state.preview = payload;
		});
	},
});

export const { clearLiSnPreview } = liSnSlice.actions;
export const liSnReducer = liSnSlice.reducer;
export const liSnSelector = (state: RootState) => state[liSnSlice.name];
export const liSnPreviewSelector = (state: RootState) => state[liSnSlice.name].preview;
